import type { CSSProperties } from 'react';
import ForwardArrowIconSvg from '../../assets/icons/forward_arrow.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const ForwardArrowIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <ForwardArrowIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default ForwardArrowIcon;
